import React, { Component } from 'react'
import { DragLayer } from 'react-dnd'
import { typeIdToName } from './BlogMenuHelper'

@DragLayer(monitor => ({
	item: monitor.getItem(),
	initialOffset: monitor.getInitialSourceClientOffset(),
	currentOffset: monitor.getSourceClientOffset(),
	isDragging: monitor.isDragging()
}))
class BlogMenuDragLayer extends Component {

	makeStyle() {
		const { initialOffset, currentOffset } = this.props
		if (!initialOffset || !currentOffset) {
			return null
		}

		return {
			display: 'block',
			position: 'fixed',
			pointerEvents: 'none',
			zIndex: 10000,
			top: currentOffset.y + "px",
			left: initialOffset.x + "px"
		}
	}

	render() {
		const { isDragging } = this.props
		if (!isDragging) {
			return null
		}

		const { item } = this.props.item

		return (
			<div className="item_drag" style={this.makeStyle()}>
				<div className="item_order">
					<div className="wrap_drag">
						<span className="ico_blog ico_drag" />
					</div>
					<span className="txt_name">{item.name}</span>

					{ item.typeId >= 9 &&
					<span className="txt_cate">
						<span className="txt_g">{typeIdToName(item.typeId)}</span>
						<span className="ico_blog" /> {item.url}
					</span>
					}
				</div>
			</div>
		)
	}
}

export default BlogMenuDragLayer
